/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const postProductSamplingProductList = (params) =>
  makeApiCall(`/product-sampling/product-list`, 'POST', params);

export const postProductSamplingSdrs = (params) =>
  makeApiCall(`/product-sampling/distributed-remaining`, 'POST', params);

export const postProductSamplingPpsrs = (params) =>
  makeApiCall(`/product-sampling/remaining-samples`, 'POST', params);

export const postProductSamplingMonthlyTrend = (params) =>
  makeApiCall(`/product-sampling/monthly-trend`, 'POST', params);
